import { render, staticRenderFns } from "./MovementList.vue?vue&type=template&id=2794eaa5&scoped=true&"
import script from "./MovementList.vue?vue&type=script&lang=js&"
export * from "./MovementList.vue?vue&type=script&lang=js&"
import style0 from "./MovementList.vue?vue&type=style&index=0&id=2794eaa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2794eaa5",
  null
  
)

export default component.exports